module.exports = __webpack_public_path__ + "img/Zuversicht.b4412553.jpg";